import React, { Component } from "react";
import SimpleDataTable from "../../../../modules/SimpleDataTable";

class BarangLainTab extends Component {
  tableColumns = [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, { rowIndex }) => <>{rowIndex + 1}</>,
      },
    },
    {
      name: "kodeBarangLain",
      label: "Kode Barang Lain",
    },
    {
      name: "namaBarangLain",
      label: "Nama Barang Lain",
    },
    {
      name: "kategoriBarangLain",
      label: "Kategori",
    },
    {
      name: "qtyBarangLain",
      label: "Qty",
    },
    {
      name: "qrCodeBarangLain",
      label: "QR Code",
    },
  ];

  render() {
    return (
      <SimpleDataTable
        data={this.props.data}
        columns={this.tableColumns}
        rowsPerPage={5}
        options={{ serverSide: false }}
      />
    );
  }
}

export default BarangLainTab;
